<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<div class="content-left-top-cornor" *ngIf="updateSelectedProcessFlowProperties()">
  <p-tabView (onChange)="onTabChange($event)" [activeIndex]="index">
    
    <p-tabPanel [headerStyleClass]="getCSSClassForPanel(0)" header="QC-Scan">
        <app-ma-preparation-qc-scan [isQCScanSelectedFromPreparationComponent]="qcScanTabActive" [scannedPlateID]="scannedPlateID" [tabId]="index" #qcScan></app-ma-preparation-qc-scan>
    </p-tabPanel>

    <p-tabPanel [headerStyleClass]="getCSSClassForPanel(1)" header="Extraction">
      <ng-template pTemplate="content">
        <app-ma-preparation-extraction [isExtractionSelectedFromPreparationComponent]="extractionTabActive" [scannedPlateID]="scannedPlateID" [tabId]="index" #extraction></app-ma-preparation-extraction>
      </ng-template>
    </p-tabPanel>

    <p-tabPanel *ngIf="is96MergeOn" [headerStyleClass]="getCSSClassForPanel(2)" header="96 Merge">
      <ng-template pTemplate="content">
        <app-ma-preparation-merge [isMergeSelectedFromPreparationComponent]="mergeTabActive" [scannedPlateID]="scannedPlateID" [tabId]="index" #merge></app-ma-preparation-merge>
      </ng-template>
    </p-tabPanel>
    
  </p-tabView>
</div>